/**
 * @name Birthdays
 * @description Componente de próximos cumpleaños
 * @author César Rivera
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import moment from 'moment';
import styled from 'styled-components';

import { EmployeeDetail } from '@components';
import { Card, Icons, MUI, Typography } from '@styles';

const Birthdays = (props) => {
  const { birthdays, onOpen, } = props;

  const month = new Date().getMonth();
  const today = moment().format('DD/MM');
  const tomorrow = moment().add(1, 'd').format('DD/MM');

  const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
    'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
  ];

  // Próximos cumpleaños
  const nextBirthdays = birthdays.filter((item) => moment(item.FechaNacimiento).format('DD/MM') >= today);

  return (
    <>
      <Card.Header divider>
        <Card.HeaderTitle>
          <Typography.H5>{`${i18n.t('Home.birthdaysMonth')} ${i18n.t(`Months.${[monthNames[month]]}`)}`}</Typography.H5>
        </Card.HeaderTitle>
        {birthdays.length !== 0 && (
          <Card.HeaderAction>
            <MUI.Tooltip title={i18n.t('GenericMessages.seeAll')}>
              <MUI.ButtonIcon onClick={onOpen}>
                <Icons.MoreHoriz />
              </MUI.ButtonIcon>
            </MUI.Tooltip>
          </Card.HeaderAction>
        )}
      </Card.Header>

      <Card.Content scroll>
        {nextBirthdays.length !== 0 ? (
          nextBirthdays.map((item, index) => {
            let bdayDate = moment(item.FechaNacimiento).format('DD/MM');

            if (bdayDate === today) {
              bdayDate = i18n.t('Home.today');
            } else if (bdayDate === tomorrow) {
              bdayDate = i18n.t('Home.tomorrow');
            } else {
              bdayDate = moment(item.FechaNacimiento).format(i18n.t('FormatDates.birthday'));
            }

            return (
              <BoxRow key={index}>
                <BirthdayEmployee>
                  <EmployeeDetail
                    avatar={item.Foto}
                    avatarSize="xs"
                    employeeName={item.Nombres}
                    employeeDetail={item.Area}
                  />
                </BirthdayEmployee>
                <BirthdayDay>
                  <Typography.Text>
                    <Typography.Small>{bdayDate}</Typography.Small>
                  </Typography.Text>
                </BirthdayDay>
              </BoxRow>
            );
          })
        ) : (
            <BoxNotFound>
              <Icons.Info />
              <Typography.H6>{`${i18n.t('Home.noBirthdaysFound')} ${i18n.t(`Months.${[monthNames[month]]}`)}`}</Typography.H6>
            </BoxNotFound>
          )}
      </Card.Content>
    </>
  );
};

Birthdays.propTypes = {
  // Array con la información de los cumpleaños del mes.
  birthdays: PropTypes.array.isRequired,
  // Función que se ejecuta para abrir el modal.
  onOpen: PropTypes.func.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxRow = styled.div`
  padding: 8px;
  display: flex;
`;

const BoxNotFound = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;

  .MuiSvgIcon-root {
    margin-right: 12px;
    font-size: 20px;
  }
`;

const BirthdayEmployee = styled.div`
  width: 80%;
`;

const BirthdayDay = styled.div`
  width: 20%;
  padding: 8px;
  align-self: center;
  text-align: end;

  & > p {
    color: ${(props) => props.theme.colors.blueMedium};
  }
`;

export default Birthdays;